import { Injectable } from '@angular/core';
import { OwnableService } from '../auth/ownable.service';
import { Channel } from './channel.model';

@Injectable({
  providedIn: 'root'
})
export abstract class ChannelService<T extends Channel> extends OwnableService<T> { }
